import axios from "../../../lib/api";
import Api from "../../../lib/api";
import { mapGovernoratesToUi, mapOrganizationsToUi } from "./mapOptionsToUi";

export const getAllGovernorates = async (filter) => {
    const response = await axios.get("/governorates", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapGovernoratesToUi(response.entities.governorates);
};

export const getBanksNames = async () => {
    try {
        const response = await axios.get("/banks");
        return response;
    } catch (error) {
        return error;
    }
};

export const getMezzaCardNames = async () => {
    try {
        const response = await axios.get("/mezza_banks");
        return response;
    } catch (error) {
        return error;
    }
};

export const getAllOrganizations = async (filter) => {
    const response = await axios.get("/organizations", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapOrganizationsToUi(response.entities.organizations);
};